import { GradeWithLessons } from "@core/grades/types";
import { trans } from "@mongez/localization";
import { GraduationCapIcon } from "lucide-react";
import { GradesCarousel } from "../components/GradesCarousel";

interface GradesListPageContentProps {
  grades: GradeWithLessons[];
}

export function GradesListPageContent({ grades }: GradesListPageContentProps) {
  if (!grades?.length) {
    return (
      <div className="app-page-canvas">
        <div className="container mx-auto max-w-[90rem] px-4 py-8 sm:px-6 lg:px-8 lg:py-12">
          <div className="app-surface py-12 text-center sm:py-16">
            <span className="mx-auto mb-5 flex size-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
              <GraduationCapIcon className="h-8 w-8" />
            </span>
            <h2 className="mb-2 text-xl font-black text-slate-950 dark:text-white sm:text-2xl">
              {trans("grades.noGradesAvailable")}
            </h2>
            <p className="text-sm text-slate-500 dark:text-slate-400 sm:text-base">
              {trans("grades.noGradesAvailableMessage")}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-page-canvas">
      <div className="container mx-auto max-w-[90rem] space-y-8 px-4 py-8 sm:space-y-12 sm:px-6 lg:px-8 lg:py-12">
        {/* Page Header */}
        <div className="app-surface relative overflow-hidden px-6 py-10 text-center sm:px-10 sm:py-14">
          <div className="pointer-events-none absolute -right-16 -top-20 size-56 rounded-full bg-primary/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-12 size-52 rounded-full bg-sky-400/10 blur-3xl" />
          <div className="relative">
            <span className="mx-auto mb-5 flex size-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-lg shadow-primary/20">
              <GraduationCapIcon className="h-7 w-7" />
            </span>
            <h1 className="text-3xl font-black tracking-tight text-slate-950 dark:text-white sm:text-4xl md:text-5xl">
              {trans("grades.title")}
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-8 text-slate-600 dark:text-slate-300 sm:text-lg">
              {trans("grades.description")}
            </p>
          </div>
        </div>

        {/* Grades Carousels */}
        <div className="space-y-8 sm:space-y-12">
          {grades.map((grade) => (
            <GradesCarousel key={grade.id} grade={grade} />
          ))}
        </div>
      </div>
    </div>
  );
}
